export default __webpack_public_path__ + "static/media/Reputation_Logo.70855d17.png";